<template>
    <c-card :class="[{ decent: type === 'decent', 'p-1': type === 'decent' }, cardClasses]">
        <c-card-header v-if="$slots.header" :class="headerClasses" class="flex items-center justify-between gap-2" style="min-height: 61px">
            <slot name="header" />
        </c-card-header>
        <c-card-body :class="bodyClasses">
            <slot />
        </c-card-body>
        <c-card-footer v-if="$slots.footer">
            <slot name="footer" />
        </c-card-footer>
    </c-card>
</template>
<script setup>
import { CCard, CCardBody, CCardFooter, CCardHeader } from '@coreui/vue/dist/esm/components/card/index.js';

const props = defineProps({
    headerClasses: [String, Array, Object],
    cardClasses: { type: [String, Array, Object], default: 'mb-4' },
    bodyClasses: { type: [String, Array, Object] },
    type: String,
});
</script>
